import Org0 from './0-radio-canada.svg';
import Org1 from './1-onf.svg';
import Org2 from './2-urbania.svg';
// import Org3 from './3-quatre95.svg';
// import Org4 from './3-quatre95.svg';
import Org5 from './5-2p2l.png';
import Org6 from './6-procirep.png';
import Org7 from './7-rolex.png';
import Org8 from './8-living.png';
import Org9 from './9-bayard.jpg';
import Org10 from './10-qds.png';
import Org11 from './11-rc.png';

export default [Org0, Org1, Org2, Org10, Org7, Org5, Org6, Org8, Org9, Org11];
